import { Component, inject, Input } from '@angular/core';
import { KpiWidgetComponent } from '../../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { BaseWidgetComponent } from '../../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../../_shared/services/filter.service';
import { formatCost, formatCostDifference } from '../../../../../../_shared/helpers/kpiWidget/kpi-formatters.helper';
import { CurrencyHelper } from '../../../../../../_shared/helpers/currency/currency-map.helper';
import { AuthService } from '../../../../../../_shared/services';
import { TranslocoService } from '@jsverse/transloco';
import { MaintenanceOverviewService } from '../../../../maintenance-overview/services/maintenance-overview.service';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';
import { KpiStatsRequest } from '../../../../maintenance-overview/models/maintenance-overview-request.model';

@Component({
  selector: 'app-overdue-maintenance',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './overdue-maintenance.component.html',
  styleUrl: './overdue-maintenance.component.scss'
})
export class OverdueMaintenanceComponent extends BaseWidgetComponent {
  private readonly transloco = inject(TranslocoService);
  @Input() selectedFilter: string;

  private authService = inject(AuthService);
  private maintenanceService = inject(MaintenanceOverviewService);
  private errorService = inject(ErrorHandlerService);

  currencySymbol: string = '';
  currencyCode: string = '';
  hasError: boolean = false;
  errorMessage: string = '';

  constructor() {
    const filterService: FilterService = inject(FilterService);
    super(filterService);
    this.title = inject(TranslocoService).translate('maintenanceDashboard.widgets.overdueMaintenance');
    this.isLoading = true;
    this.value = 0;
    this.percentageDifference = 0;

    this.currencyCode = this.authService.getUserSettings()?.currencyCode ?? 'ZAR';
    this.currencySymbol = CurrencyHelper.getCurrencySymbol(this.currencyCode);
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    this.isLoading = true;
    this.hasError = false;

    try {
      this.cancelSubject.next();
      const request: KpiStatsRequest = {
        accountIds: this.widgetFilter.accountIds,
        timeFrom: this.widgetFilter.startDate!,
        timeTo: this.widgetFilter.endDate!,
        previousTimeFrom: this.widgetFilter.previousCycleStartDate!,
        previousTimeTo: this.widgetFilter.previousCycleEndDate!,
        maintenanceModel: null
      }
      const response = await this.maintenanceService.getOverdueKpiStats(request, this.cancelSubject);
      this.value = response.data?.totalValue ?? 0;
      this.percentageDifference = response.data?.percentageChange ?? 0;

      this.isLoading = false;
    } catch (error: any) {
      this.errorService.handleError(error, {
        callback: (errorMessage) => {
          this.hasError = true;
          this.errorMessage = errorMessage;
          this.isLoading = false;
        }
      });
    }
  }

  public override formatValue(value: number): string {
    return `${value.toLocaleString()}`;
  }

  public formatCost(value: number): string {
    return formatCost(value, this.currencySymbol);
  }

  public formatCostDifference(value: number): string {
    return formatCostDifference(value, this.selectedFilter, this.currencySymbol, (key, params) => this.transloco.translate(key, params));
  }
}
